module.exports = __webpack_public_path__ + "fonts/AmazonEmber-Regular.23f7e6c.woff";